import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

import { DirectivesModule } from 'ish-core/directives.module';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { PipesModule } from 'ish-core/pipes.module';
import { SuggestProductsTileComponent } from 'ish-shared/components/search/suggest-products-tile/suggest-products-tile.component';

@Component({
  selector: 'ish-suggest-products',
  imports: [CommonModule, PipesModule, DirectivesModule, TranslatePipe, RouterModule, SuggestProductsTileComponent],
  templateUrl: './suggest-products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestProductsComponent {
  readonly products = input.required<string[]>();
  readonly maxAutoSuggests = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly deviceType = input<DeviceType>(undefined);
  readonly routeChange = output<void>();

  handleInputFocus(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.routeChange.emit();
  }
}
